import { useTranslation } from "react-i18next";
import CategoryDropdown from "@/components/base/CategoryDropdown";
import { MAIN_SITE_URL } from "@/constants";

const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=A%20wide%20editorial%20scene%20of%20neatly%20arranged%20fashion%20products%20including%20a%20pair%20of%20white%20sneakers%20a%20folded%20hoodie%20and%20a%20leather%20bag%20on%20a%20soft%20warm%20beige%20studio%20backdrop%20with%20gentle%20morning%20light%20and%20lots%20of%20negative%20space&width=1600&height=900&seq=hero-main-v2&orientation=landscape&nocache=true";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[560px] items-center justify-center px-4 md:min-h-[640px] md:px-6">
      <img
        src={HERO_IMAGE}
        alt="Basetao Spreadsheet product still life with sneakers, hoodie and accessories"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45" />

      <div className="relative z-10 flex w-full max-w-3xl flex-col items-center text-center">
        <span className="mb-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/25 bg-white/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-white backdrop-blur">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-sparkling-line text-sm" />
          </span>
          {t("hero.badge")}
        </span>

        <h1 className="font-heading text-3xl font-semibold leading-tight text-white md:text-5xl">
          {t("hero.title")}
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-table-2 text-base" />
            </span>
            {t("hero.cta1")}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:w-auto"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-shopping-bag-line text-base" />
            </span>
            {t("hero.cta2")}
          </a>
        </div>

        <div className="mt-8 w-full max-w-md">
          <p className="mb-2 text-xs font-medium text-white/70">{t("hero.dropdownLabel")}</p>
          <CategoryDropdown />
        </div>
      </div>
    </section>
  );
}